import React from 'react'
import ResponseTree from './ResponseTree'
import ResponseForm from './ResponseForm'
import TopicCardInfos from './TopicCardInfos'
import TopicCardDescription from './TopicCardDescription'

const ResponseTreeItem = ({
  _id,
  topico_id,
  curso_id,
  category,
  title,
  description,
  loading,
  visualizacoes,
  link = true,
  detail = false,
  createdAt,
  postadoPor,
  respostas = [],
  query,
  countLevel = 1,
  ...rest
}) => {
  if (loading) {
    return (
      <div>
        <TopicCardInfos loading={loading} visualizacoes={visualizacoes} />
        <TopicCardDescription loading={loading}>{description}</TopicCardDescription>
      </div>
    )
  }

  return (
    <div>
      <TopicCardInfos deleteButton resposta_id={_id} postadoPor={postadoPor} createdAt={createdAt} loading={loading} visualizacoes={visualizacoes} />
      <TopicCardDescription loading={loading}>{description}</TopicCardDescription>
      {!!(countLevel < 2) &&<ResponseForm query={query} topico_id={topico_id} curso_id={curso_id} resposta_id={_id} />}
      <ResponseTree hideOpenButton={countLevel === 2} totalResponses={respostas.length}>
        {(respostas || []).map(resposta => {
          return (
            <ResponseTreeItem query={query} topico_id={topico_id} _id={resposta._id} description={resposta.descricao} postadoPor={resposta.postadoPor} createdAt={resposta.createdAt} countLevel={countLevel + 1} respostas={resposta.respostas} />
          )
        })}
        {!!(countLevel === 2) &&<ResponseForm query={query} topico_id={topico_id} resposta_id={_id} curso_id={curso_id} />}
      </ResponseTree>
    </div>
  )
}
export default ResponseTreeItem
